import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import SelfieCapture from '../../components/SelfieCapture/SelfieCapture';
import { getQueryString } from '../../helpers/url';

const SignUpSelfie = () => {
  const history = useHistory();
  const phone = getQueryString('phone');
  const token = getQueryString('token');
  const countryCode = getQueryString('countryCode');
  const email = getQueryString('email');
  const firstName = getQueryString('firstName');
  const lastName = getQueryString('lastName');
  const rp = getQueryString('rp');
  const city = getQueryString('city');
  const affiliateType = getQueryString('affiliateType');
  const sectorAffiliate = getQueryString('sectorAffiliate');
  const hotelName = getQueryString('hotelName');
  const jobtitle = getQueryString('jobtitle');
  const workUnit = getQueryString('workUnit');

  const handleConfirmFace = (img) => {
    let query = `?phone=${phone}&countryCode=${countryCode}&email=${encodeURIComponent(
      email,
    )}&token=${token}&firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(
      lastName,
    )}`;
    if (rp) query += `&rp=${rp}`;
    if (city) query += `&city=${city}`;
    if (affiliateType) query += `&affiliateType=${encodeURIComponent(affiliateType)}`;
    if (sectorAffiliate) query += `&sectorAffiliate=${encodeURIComponent(sectorAffiliate)}`;
    if (jobtitle) query += `&jobtitle=${encodeURIComponent(jobtitle)}`;
    if (hotelName) query += `&hotelName=${encodeURIComponent(hotelName)}`;
    if (workUnit) query += `&workUnit=${encodeURIComponent(workUnit)}`;

    history.push({
      pathname: '/sign-up-create-password',
      search: query,
      state: {
        selfie: img,
      },
    });
  };

  return (
    <>
      <Header />
      <ContentApp classes='pt-0'>
        <SelfieCapture onConfirm={handleConfirmFace} />
      </ContentApp>
    </>
  );
};

export default SignUpSelfie;
